import { render } from "./PersonDetailsCard.vue?vue&type=template&id=4d3303a9&ts=true"
import script from "./PersonDetailsCard.vue?vue&type=script&lang=ts"
export * from "./PersonDetailsCard.vue?vue&type=script&lang=ts"

import "./PersonDetailsCard.vue?vue&type=style&index=0&id=4d3303a9&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__